import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <img width="960" alt="An image displaying each header from h1 to h6" src="https://user-images.githubusercontent.com/586552/217705129-6422d0c0-dacc-4c98-90c0-9380fb001e83.png" />
    <h2>{`Usage`}</h2>
    <p>{`Headings are used to structure the content on the page, with each heading representing a different level of importance. It is recommended to use headings in a logical manner to create a clear hierarchy and improve accessibility.`}</p>
    <ul>
      <li parentName="ul">{`Heading should be used to communicate page organization and hierarchy.`}</li>
      <li parentName="ul">{`Use Heading as the title of a section or sub section.`}</li>
      <li parentName="ul">{`Do not use Heading for styling alone. For simply styling text, use text with relevant styling.`}</li>
    </ul>
    <p>{`The Heading component will render an html h2 tag without any default styling.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`While sighted users rely on visual cues such as font size changes to determine what the heading is, assistive technology users rely on programatic cues that can be read out. When text on a page is visually implied to be a heading, ensure that it is coded as a heading. Additionally, visually implied heading level and coded heading level should be consistent. See `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/WCAG21/Understanding/info-and-relationships.html"
      }}>{`WCAG success criteria: 1.3.1: Info and Relationships`}</a>{`.`}</p>
    <p>{`Headings allow assistive technology users to quickly navigate around a page. Navigation to text that is not meant to be a heading can be a confusing experience. `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/page-structure/headings/"
      }}>{`Learn more about best heading practices (WAI Headings)`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      